<template>
    <div class="layout-container">
        <Header :style="{position: 'absolute', left: 0, top: 0, right: 0}">
            <div slot="right" class="align-center">
                <el-popover style="padding: 0;" placement="bottom-start" trigger="click" width="227" v-model="popVis">
          <span class="align-center" style="cursor: pointer;" slot="reference">
            <head-img :size="34" style="border-radius: 17px" :src="userInfo.profilePicture + '?x-oss-process=image/resize,w_50,limit_0'" :name="userInfo.name" />
            <span class="username">{{userInfo.name}}</span>
            <i class="el-icon-caret-bottom"></i>
          </span>
                    <template>
                        <div class="pop-menu">
                            <div class="pop-menu-item" @click="logout">退出登录</div>
                        </div>
                    </template>
                </el-popover>
            </div>
        </Header>
        <div class="inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import HeadImg from "./HeadImg";
    import {mapState, mapActions} from 'vuex'
    export default {
        name: "normalLayOut",
        components: {
            Header,
            HeadImg
        },
        data () {
            return {
                popVis: false,
            }
        },
        computed: {
            isAuthedOrg() {
                if (!this.orgInfo) {
                    return false;
                }
                return !!this.orgInfo.isAuthentication;
            },
            isAdmin() {
                if (!this.userInfo) {
                    return false;
                }
                return this.userInfo.type === 1 || this.userInfo.type === 1;
            },
            ...mapState('user',['userInfo','orgInfo'])
        },
        methods: {
            ...mapActions('user',['ExitUser']),
            toPlatform() {
                window.location.href=process.env.VUE_APP_SITE_HOST;
            },
            toAuth() {
                window.location.href=`${process.env.VUE_APP_SITE_HOST}/pc/platform/index.html#/recognize?orgId=${this.userInfo.orgId}`;
            },
            async logout () {
                await this.ExitUser();
                this.$router.push({path:'/'})
            }
        }
    }
</script>

<style scoped>
    .layout-container{
        background-color: #E7E8EB;
        overflow-x: hidden;
        width: 100%;
        height: 100%;
        position: relative;
        padding-top: 90px;
        box-sizing: border-box;
    }

    .inner{
        width: 1200px;
        background-color: white;
        min-height: 800px;
        margin: auto;
    }

    .pop-menu-item{
        height: 32px;
        color: #606266;
        font-size: 14px;
        cursor: pointer;
        line-height: 32px;
        padding-left: 10px;
    }
    .pop-menu-item:hover{
        color: #3389FF;
        background-color: rgba(51, 137, 255, 0.05);
    }
</style>